module.exports = __webpack_public_path__ + "img/nbus_box_object_2.ccc950bc.png";